import type { DictEntryWithExamples } from '../lib/types.js';
import { WordCell } from './WordCell.js';

type Props = {
  entries: DictEntryWithExamples[];
  selected: ReadonlySet<string>;
  submitting: boolean;
  onToggle: (word: string) => void;
  onSubmit: () => void;
};

export function TestSelectPage({
  entries,
  selected,
  submitting,
  onToggle,
  onSubmit,
}: Props): JSX.Element {
  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="flex-1 min-h-0 overflow-y-auto px-4 pt-2 pb-4 grid grid-cols-2 gap-3 auto-rows-fr">
        {entries.map((e) => (
          <WordCell
            key={e.word}
            word={e.word}
            selected={selected.has(e.word)}
            onToggle={() => onToggle(e.word)}
          />
        ))}
      </div>
      <div className="sticky bottom-0 px-4 pt-3 pb-[max(20px,env(safe-area-inset-bottom))] bg-canvas border-t border-border">
        <button
          type="button"
          disabled={submitting || entries.length === 0}
          onClick={onSubmit}
          className="w-full h-12 rounded-xl bg-primary text-canvas font-medium disabled:bg-surface-2 disabled:text-muted"
        >
          {submitting ? '保存中…' : '下一页'}
        </button>
      </div>
    </div>
  );
}
